import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import "./modals-styles.scss"
import useSubscriptionActions from '../../../hooks/actions/subscription.hooks';

const TrialPeriodModal = ({ show,hideModal, subscriptionData, subsciptionId, accountId, onSuccess }) => {
  const [days, setDays] = useState(0);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const { extendTrialPeriod } = useSubscriptionActions();

  const handleExtendTrialPeriod = () => {
    setLoading(true);
    extendTrialPeriod({ accountId, subscriptionId: subsciptionId, days, reason }).then((res) => {
      setLoading(false);
      onSuccess();
    });
  }

  if (!show) return null;
  return (
    <Modal
    show={show}
    dialogClassName=""
    className="modal-height-auto modal-radius-8 "
    aria-labelledby="asset-modal"
    centered
    scrollable
    onHide={hideModal}

  >

<Modal.Body className='p-3'>
    <div className='f-16 f-500 mb-3'>Extend Trial Period</div>
    {subscriptionData?.TrailDetails?.Trials?.length > 0 && (
      <>
        <div className='f-14 f-darkgrey mb-3'>Previous Trials</div>
        {subscriptionData?.TrailDetails?.Trials?.map((trial) => (
          <div className='d-flex align-items-center justify-content-between mb-3'>
              <div>
                  <span className='f-black mr-3'>{trial?.ValidUpto}</span>
                <span className='f-darkgrey'>{trial?.Status}</span>
            </div>
            <div>{trial?.Days}</div>
        </div>
      ))}
      </>
    )}
    
    <div className='f-14 f-darkgrey mb-2'>Days to extend</div>
    <div className='highlight-input-with-grey-border w-100 radius-4 d-flex align-items-center justify-content-between mb-2'>
<div className='flex-1'>
    <input
    type='number'
    className='w-100 border-none bg-transparent p-2'
    value={days}
    onChange={(e) => setDays(e.target.value)}
    />
</div>
<div className='f-500 f-grey mr-2'>Day(s)</div>
    </div>
    <div className='f-14 f-darkgrey mb-2'>Reason</div>
    <textarea
    rows={8}
    className='w-100 p-2 border-grey radius-4'
    placeholder='Reason'
    value={reason}
    onChange={(e) => setReason(e.target.value)}
    />
</Modal.Body>

<Modal.Footer className='p-2 d-flex align-items-center justify-content-end border-none'>
    <Button 
      className='hg-cancel-btn mr-2'
      onClick={hideModal}
    >
      Cancel
    </Button>
    <Button 
      className='hg-blue-btn'
      onClick={handleExtendTrialPeriod}
      disabled={loading || days <= 0}
    >
      {loading ? "Extending..." : "Extend Trial"}
    </Button>
</Modal.Footer>
  </Modal>
  )
}

export default TrialPeriodModal